import Navigator from "../../../../publicComponent/h5/Navigator";
import { useQueryParam } from "../../../../hooks";
import { useTranslation, getI18n } from "react-i18next";
import { HeaderMall9 } from "../../../../publicComponent/Header";
import { useEffect, useState } from "react";
import { useGetAgentIdByDomainName } from "../../../../api/agent";
import FooterMall9 from "../../../../publicComponent/Footer/FooterMall9";
import { useLocation, useNavigate } from "react-router";

export default function Agreement() {
  const [type] = useQueryParam("type");
  const { t } = useTranslation();
  const { getAgent } = useGetAgentIdByDomainName();
  const [protocal, setProtocal] = useState({});
  const name = type === "reg" ? "注册协议" : "隐私协议";
  const lang = getI18n().language;
  const [content, setContent] = useState("");
  const location = useLocation();

  const getDomainInfo = async () => {
    let { data, error } = await getAgent();

    if (data) {
      setProtocal(data);
    }
  };

  useEffect(() => {
    getDomainInfo();
  }, []);

  useEffect(() => {
    if (type === "reg") {
      if (lang === "en") {
        setContent(protocal.enRegProtocal);
      } else {
        setContent(protocal.regProtocal);
      }
    } else if (type === "privacy") {
      if (lang === "en") {
        setContent(protocal.enPriProtocal);
      } else {
        setContent(protocal.priProtocal);
      }
    } else {
      if (lang === "en") {
        setContent(protocal.enTermsAndConditions);
      } else {
        setContent(protocal.termsAndConditions);
      }
    }
  }, [protocal, lang, location]);

  return (
    <>
      <Navigator title={t(name)} goback />

      <HeaderMall9 />
      <Navigator.container className="pt-[108px] w-[800px] moile py-[20px] min-h-[60vh]">
        <div
          className="p-[15px]"
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        ></div>
      </Navigator.container>
      <FooterMall9 noTabs />
    </>
  );
}
